export function percentChange(from, to) {
  if (!from) {
    // eslint-disable-next-line no-magic-numbers
    from = 0.000001;
  }
  return ((to - from) / from) * 100;
}
